import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { Input } from 'antd'
import { Text } from '@lmc/ui-kit/src/general'
import { Stack } from './ReconcileModalStack'

export type DontPayReasonFieldsProps = {
  id: string
  rows: number
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export function DontPayReasonFields({
  id,
  rows,
  value,
  onChange,
  disabled
}: DontPayReasonFieldsProps) {
  const { t } = useTranslation()
  return (
    <Stack $gap={16} $mt={8}>
      <ExplanationText>
        {t('RECONCILIATION_DONT_PAY_CONFIRM_BODY')}
      </ExplanationText>
      <Stack>
        <ReasonLabel htmlFor={id}>
          <ReasonAsterisk aria-hidden>*</ReasonAsterisk>
          {t('RECONCILIATION_DONT_PAY_REASON_LABEL_TEXT')}
        </ReasonLabel>
        <Input.TextArea
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('RECONCILIATION_DONT_PAY_REASON_PLACEHOLDER')}
          rows={rows}
          disabled={disabled}
        />
      </Stack>
    </Stack>
  )
}

const ExplanationText = styled(Text).attrs({ level: 2, weight: 'medium' })`
  display: block;
  color: ${({ theme }) => theme.color.neutral.color4};
`

const ReasonLabel = styled.label`
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 16px;
  color: ${({ theme }) => theme.color.neutral.color4};
`

const ReasonAsterisk = styled.span`
  color: ${({ theme }) => theme.color.status.danger};
  flex-shrink: 0;
`
